export default "__VITE_ASSET__Dfd3vYEX__"